import { useState } from "react";
import { AutoComplete } from "@/core/components/ui/autocomplete";
import { useBusiness } from "@/core/business";

const BusinessSelector = () => {
  const { businesses, selectedBusinessId, selectBusiness, isLoading } =
    useBusiness();
  const [searchValue, setSearchValue] = useState("");

  const handleSelect = (businessId: string) => {
    selectBusiness(businessId);
  };

  // Format businesses for the autocomplete component
  const options = businesses.map((business) => ({
    value: business.id,
    label: business.name,
  }));

  // Show loading state while businesses are loading
  if (isLoading) {
    return (
      <div className="mr-4 w-64 pt-1">
        <div className="h-10 w-full animate-pulse rounded-md bg-gray-200" />
      </div>
    );
  }

  // Only show selector for tenant users with multiple businesses to select from
  if (businesses.length <= 1) {
    return null; // Don't show selector if only one or no business is available
  }

  return (
    <div className="mr-4 w-64 pt-1">
      <AutoComplete
        selectedValue={selectedBusinessId || ""}
        onSelectedValueChange={handleSelect}
        searchValue={searchValue}
        onSearchValueChange={setSearchValue}
        placeholder="Select a business"
        items={options}
        className="h-10 bg-secondary"
      />
    </div>
  );
};

export default BusinessSelector;
